import React from "react";
import PropTypes from "prop-types";

/**
 * Esqueleto de carga para TableThree.
 * Conserva la misma estructura visual que la tabla real para que la
 * transición no salte. Usa tokens semánticos.
 */
const SkeletonTable = ({ columns, rows }) => {
  return (
    <div
      className="rounded-md border bg-surface dark:bg-dark-surface
                 border-border-default dark:border-dark-border-default
                 px-5 pb-2.5 pt-6 shadow-default dark:shadow-none
                 sm:px-7.5 xl:pb-1"
    >
      <div className="max-w-full overflow-x-auto">
        <table className="w-full table-auto">
          <thead>
            <tr className="bg-surface-muted dark:bg-dark-surface-muted text-left">
              <th className="min-w-[24px] px-4 py-4 font-medium text-text-default dark:text-dark-text-default xl:pl-11">
                #
              </th>
              {columns.map((head, index) => (
                <th
                  key={`th-${index}`}
                  className={`px-4 py-4 font-medium text-text-default dark:text-dark-text-default ${head.style ?? ""}`}
                >
                  {head.title}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Array(rows)
              .fill(undefined)
              .map((_, index) => (
                <tr key={`tr-${index}`}>
                  <td className="border-b border-border-default dark:border-dark-border-default px-4 py-5 pl-9">
                    <div className="skeleton h-4 w-full"></div>
                  </td>

                  {columns.map((item, key) => (
                    <td
                      key={`td-${key}`}
                      className="border-b border-border-default dark:border-dark-border-default px-4 py-5"
                    >
                      <div className="skeleton h-4 w-full"></div>
                    </td>
                  ))}
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SkeletonTable;

SkeletonTable.propTypes = {
  columns: PropTypes.array.isRequired,
  rows: PropTypes.number.isRequired,
};
